import { render, staticRenderFns } from "./AddItemTabelaPrecoListAddNew.vue?vue&type=template&id=2313c7d0&"
import script from "./AddItemTabelaPrecoListAddNew.vue?vue&type=script&lang=js&"
export * from "./AddItemTabelaPrecoListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./AddItemTabelaPrecoListAddNew.vue?vue&type=style&index=0&id=2313c7d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports